import React, { useState, useEffect, useRef } from 'react';
import $ from 'jquery';
import { Button, Container, Row, Col, Card, Alert, Table, Spinner } from 'react-bootstrap';
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css"; 
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; 
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx'; 
import Header from '../Header';

const AllTickets = () => {

  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);
  const tableRef = useRef(null);
  const navigate = useNavigate();

  // Fetch tickets data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/gettickets`);
        
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const result = await response.json();  
        //console.log(result);
        setTickets(result.ticket || []);  
      } catch (error) {
        console.error("Error fetching data:", error); 
        setError(error.message);  
      } finally {
        setLoading(false);  
      }
    };

    fetchData(); 
  }, []);

  // Initialize DataTable after tickets data is fetched
  useEffect(() => {
    if (tickets.length > 0 && tableRef.current) {
      const table = $(tableRef.current).DataTable({
        responsive: true,
        autoWidth: false,
        destroy: true, 
        paging: true,
        pageLength: 10, 
        lengthMenu: [10, 25, 50, 100], 
        columnDefs: [
          { targets: 0, responsivePriority: 1 },
          { targets: 1, responsivePriority: 2 },
          { targets: 2, responsivePriority: 3 },
          { targets: 3, responsivePriority: 4 },
          { targets: 4, responsivePriority: 5 },
          { targets: 5, responsivePriority: 6 },
          { targets: 6, responsivePriority: 7 },
        ],
      });

      return () => {
        table.destroy(); // Cleanup on unmount
      };
    }
  }, [tickets]);

  const exportToExcel = () => {
    if (tickets.length === 0) {
      alert("No data to export");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(tickets);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "tickets");

    XLSX.writeFile(wb, "Tickets_List.xlsx");
  };

  if (loading) {
    return (
      <Container fluid className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <Spinner animation="border" variant="primary" />
      </Container>
    );
  }

  return (
    <>
      <Header />
      <Container fluid className="shadow mx-1 px-3 bg-light rounded-3">
        <Row className="d-flex align-items-center justify-content-between p-3 mt-3">
          <Col>
            <h4 className="mb-0">All Tickets</h4>
          </Col>
          <Col className="text-end">
            <Button variant="success" onClick={exportToExcel}>
              Export to Excel
            </Button>
          </Col>
        </Row>

        {error && <Alert variant="danger">{error}</Alert>}

        <Card>
          <Card.Header>Tickets List</Card.Header>
          <Card.Body>
            <div className="table-responsive">
              <Table ref={tableRef} striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>S.no</th>
                    <th>Ticket Id</th> 
                    <th>User</th>   
                    <th>Subject</th>
                    <th>Description</th>
                    <th>Emp Description</th>
                    <th>File</th>
                    <th>Manager</th>
                    <th>Assign To</th>
                    <th>Raise By</th>
                    <th>Transfer To</th>
                    <th>Status</th>
                    <th>Assigned On</th>
                    <th>Raised On</th>
                    <th>Closed On</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {tickets.length > 0 ? (
                    tickets.map((ticket, index) => (
                      <tr key={ticket.id}>
                        <td>{index + 1}</td>
                        <td className="text-danger">{ticket.ticket_id || 'N/A'}</td>
                        <td className="text-primary">{ticket.Username || 'N/A'}</td>
                        <td>{ticket.Subject || 'N/A'}</td>
                        <td>{ticket.Description || 'N/A'}</td>
                        <td>{ticket.emp_Description || 'N/A'}</td>
                        <td>
                          {ticket.emp_file ? (
                            <a href={`https://apiaksharaconnect.aksharafinalytics.in/${ticket.emp_file}`} download={ticket.emp_file || 'N/A'} title='Download'>
                              <Button variant="warning" size="sm" className="ms-2">
                                <FontAwesomeIcon icon={faDownload} /> 
                              </Button>
                            </a>
                          ) : (
                            <span>No file available</span>
                          )}
                        </td>
                        <td className="text-primary">{ticket.MgrName || 'N/A'}</td>
                        <td className="text-primary">{ticket.EmpName || 'N/A'}</td>
                        <td>{ticket.RaisedByEmpName || 'N/A'}</td>
                        <td>{ticket.TransferEmpName || 'N/A'}</td>
                        <td className={ticket.status === 'closed' ? 'text-danger' : 'text-primary'}>
                            {ticket.status || 'N/A'}
                        </td>
                        <td>{ticket.assigned_date || 'N/A'}</td>
                        <td>{ticket.doa || 'N/A'}</td>
                        <td>{ticket.closed_date || 'N/A'}</td>
                        <td>
                          <button className="btn btn-primary" onClick={() => navigate(`/Tqueries/${ticket.ticket_id}`)}>
                              View
                          </button>
                        </td>  
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="16" className="text-center">No Tickets available</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default AllTickets;
